import {queryOptions} from '@tanstack/react-query';

import {keys} from '@queries/keys';

import {getTariffs} from './getTariffs';

export const tariffsQueryOptions = () =>
  queryOptions({
    queryKey: keys.tariffs.current(),
    queryFn: getTariffs,
    staleTime: 60_000,
  });
